module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis documentos para firmar")])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('upload-image', {
    attrs: {
      "name": "adjuntar_documento_importante",
      "onlyPdf": "true",
      "folder": "documentos_firmar_empleado"
    },
    on: {
      "save": _vm.guardarDocumentoSubido,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjunte un PDF")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_c('strong', [_vm._v("Se agregará el sello de firma digital cuando se suba el archivo.")])]), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEliminar()
      },
      "do": function($event) {
        return _vm.eliminarDocumento()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el pdf subido?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEliminar()
      },
      "do": function($event) {
        return _vm.eliminarDocumento()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el pdf subido?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e()]), _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Al subir el pdf se agregará el sello de firma")])]), _c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small mb-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading && _vm.lista.length > 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))]), (o.revisado) ? _c('div', {
      staticClass: "seen name fs-12"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Aprobado por RRHH")])]) : _vm._e()])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(!o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small is-primary",
      class: {
        'is-loading': _vm.downloading
      },
      attrs: {
        "disabled": _vm.downloading
      },
      on: {
        "click": function($event) {
          return _vm.descargarDocumento(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-download is-small fs-12"
    })]), _c('span', [_vm._v("Descargar documento")])]) : _vm._e(), (!o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small",
      attrs: {
        "disabled": !o.fechaDescarga
      },
      on: {
        "click": function($event) {
          return _vm.confirmacionSubirPdf(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    })]), _c('span', [_vm._v("Subir y firmar PDF")])]) : _vm._e(), (o.rutaSubido) ? _c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.rutaSubido,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye is-small fs-12"
    })]), _c('span', [_vm._v("Ver PDF")])]) : _vm._e(), (o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmacionEliminarPdf(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])]) : _vm._e()])])])
  }), 0)], 1) : _vm._e(), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron documentos por firmar")])]) : _vm._e()], 1)], 1)])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a7e0f9c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Mis_Documentos_Firmar.vue
// module id = 824
// module chunks = 0